export default "__VITE_ASSET__BQJvkAST__"